import { companyInfo } from '@/mocks/home';

const WHATSAPP_NUMBER = companyInfo.phone1.replace(/\s/g, '').replace('+', '');

export function getWhatsAppUrl(serviceName: string): string {
  const message = `Hi Infinite Consultant & Services,\n\nI am interested in your "${serviceName}" service.\n\nPlease share more details, pricing and availability.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export function getGenericWhatsAppUrl(): string {
  const message = `Hello Infinite Consultant & Services,\n\nI am interested in your services.\n\nPlease share:\n• More Details\n• Pricing\n• Packages\n• Project Timeline\n\nThank You.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}